<!--
 * @Author: Antigravity
 * @Date: 2026-03-23
 * @Description: 游客分析
-->

<template>
  <div class="w-full flex flex-col px-16 pb-49">
    <ChannelCountCell ref="channelCountCellRef" />
    <TripModeCountCell ref="tripModeCountCellRef" class="mt-4" />
    <OriginCountCell ref="originCountCellRef" class="mt-4" />
  </div>
</template>

<script>
import ChannelCountCell from './comps/ChannelCountCell.vue';
import TripModeCountCell from './comps/TripModeCountCell.vue';
import OriginCountCell from './comps/OriginCountCell.vue';

export default {
  name: "TouristAnalysis",
  components: {
    ChannelCountCell,
    TripModeCountCell,
    OriginCountCell
  },
  data() {
    return {
    }
  },
  computed: {
    deptInfo() {
      return this.$store.state.complaint.deptInfo;
    }
  },
  mounted() {
    // 各个 Cell 已通过 visualFilterMixin 实现自动按需加载
  }
};
</script>

<style lang="less" scoped>
.wrap {
  margin: 0 12px 12px;
  margin-bottom: 49px;
}
</style>
